import { useMemo } from 'react'

interface Props {
  children: number | string
  onClick?: () => void
  isSelected?: boolean
  isWrong?: boolean
}

const NumericButton = ({ children, onClick, isSelected = false, isWrong = false }: Props): React.ReactElement => {
  const buttonStateClass = useMemo(() => {
    if (isWrong) {
      return 'bg-red-wrong-choice text-white border-red-wrong-choice'
    }

    if (isSelected) {
      return 'bg-purple text-white'
    }

    return 'bg-white hover:bg-purple/20 text-purple border-purple'
  }, [isSelected, isWrong])

  return (
    <button
      className={`w-16 sm:w-24 h-16 sm:h-24 ${buttonStateClass} border-2 rounded inline-block text-xs sm:text-lg font-semibold transition-colors`}
      onClick={onClick}
      type="button"
    >
      {children}
    </button>
  )
}

export default NumericButton
